$(document).ready(initRedirectToDirp);

function ucwords(str) {
    return (str).replace(/^([a-z])|\s+([a-z])/g, ($1) => $1.toUpperCase());
}

function buildRedirectURL(title, location) {
    let url = '';
    const array = location.split(',');
    switch (array.length) {
        case 1:// state level
            url = `/Jobs/${ucwords(title).replaceAll(' ', '-')}/--in-${array[0].replaceAll(' ', '-')}`;
            break;
        case 2: // city level
              url = `/Jobs/${ucwords(title).replaceAll(' ', '-')}/-in-${array[0].replaceAll(' ', '-')},${array[1].replaceAll(' ', '')}`;
            break;
        case 3: // neighborhood level
            url = `/Jobs/${ucwords(title).replaceAll(' ', '-')}/-in-${array[1].replaceAll(' ', '-').slice(1)},${(array[2].replaceAll(' ', ''))}`;
            break;
        default:
            url = `/Jobs/${ucwords(title).replaceAll(' ', '-')}/-in-${location.replaceAll(' ', '-')}`;
    }
    return url;
}

function initRedirectToDirp() {
    $(document).on('submit', '[data-redirect-dirp]', (event) => {
      event.preventDefault();
      const searchTitle = $('.search_form [name="search"]').val();
      const searchLocation = $('.search_form [name="location"]').val();
      window.location.href = buildRedirectURL(searchTitle, searchLocation);
    });
}
